import { render, staticRenderFns } from "./addVendro.vue?vue&type=template&id=6e4c8afc"
import script from "./addVendro.vue?vue&type=script&lang=js"
export * from "./addVendro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports